export default theme => ({
  // eslint-disable-line
  iconRowInner: {
    "& .gatsby-image-wrapper": {
      margin: "0 0 12px 12px",
    },
  },
})
